import { HashRouter as Router, Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import LoginRoute from "../components/LoginRoute";
import RecoverRoute from "../components/RecoverRoute";
import RedirectRoute from "../components/RedirectRoute";
import MainRoute from "../components/MainRoute";
import { useQuery } from "react-query";
import custom from "../utils/custom";
import axios from "../utils/axios";
import { setStore } from "../utils/global";

export default function RouterProvider() {
  const { isLoading } = useQuery({
    queryKey: ["logger_user_info"],
    queryFn: () => axios.post("client/api/user/info"),
    onSuccess: ({ data, success }) => {
      if (success) {
        document.querySelector("#preload")?.setAttribute("loading", "0");
        setStore("user", data.detail);
      } else {
        custom.removeCookie("token");
        document.querySelector("#preload")?.setAttribute("loading", "0");
      }
    },
    refetchOnWindowFocus: true,
  });

  if (isLoading) {
    return null;
  }

  return (
    <div className="main relafull">
      <BrowserRouter>
        <Router>
          <Switch>
            <Route path="/login" component={LoginRoute} />
            <Route path="/recover" component={RecoverRoute} />
            <Route path="/redirect" component={RedirectRoute} />
            <ProtectedRoute path="/:main/:mainfilter/:pop/:popfilter" component={MainRoute} />
            <Redirect to="/home/0/0/0" />
          </Switch>
        </Router>
      </BrowserRouter>
      <div className="clear_div" />
    </div>
  );
}

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = custom.getCookie("token");

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login/mobile",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
